import { render, staticRenderFns } from "./KisilerRolAtama.vue?vue&type=template&id=c05fb1ca&scoped=true"
import script from "./KisilerRolAtama.vue?vue&type=script&lang=ts"
export * from "./KisilerRolAtama.vue?vue&type=script&lang=ts"
import style0 from "./KisilerRolAtama.vue?vue&type=style&index=0&id=c05fb1ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05fb1ca",
  null
  
)

export default component.exports